<template>
  <spinner v-if="loading" :center="true" />
  <div v-else>
    <div class="py-3">
      <b-form @submit="onSubmit" class>
        <b-container fluid class="col-8 border-secondary mx-auto border__div p-4 mb-2">
          <h2 class="pb-2">Inserisci i dati anagrafici</h2>
          <b-row class="my-1 justify-content-around">
            <b-col sm="4" class="align-self-center text-left text-secondary">
              <label for="nome" class="text-right">Nome*:</label>
            </b-col>
            <b-col sm="6">
              <b-form-input
                v-model="form.nome"
                type="text"
                id="nome"
                required
                placeholder="Inserisci Nome*"
                class="my-2"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1 justify-content-around">
            <b-col sm="4" class="align-self-center text-left text-secondary">
              <label for="nome" class="text-right">Cognome*:</label>
            </b-col>
            <b-col sm="6">
              <b-form-input
                v-model="form.cognome"
                type="text"
                id="cognome"
                required
                placeholder="Inserisci Cognome*"
                class="my-2"
              ></b-form-input>
            </b-col>
          </b-row>

          <div v-if="user.role != 'admin'">
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Regione*:</label>
              </b-col>
              <b-col sm="6">
                <!-- <b-form-input
                  v-model="form.regione"
                  type="text"
                  id="regione"
                  required
                  placeholder="Inserisci Regione*"
                  class="my-2"
                ></b-form-input>-->
                <b-form-select
                  id="regione"
                  class="my-2"
                  v-model="form.regione"
                  :options="regioni"
                  placeholder="Inserisci regione*"
                  @change="getProvincie"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Provincia*:</label>
              </b-col>
              <b-col sm="6">
                <!-- <b-form-input
                  v-model="form.provincia"
                  type="text"
                  id="provincia"
                  required
                  placeholder="Inserisci Provincia*"
                  class="my-2"
                ></b-form-input>-->
                <b-form-select
                  id="provincia"
                  class="my-2"
                  v-model="form.provincia"
                  :options="province"
                  placeholder="Inserisci provincia*"
                  @change="getComuni"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Comune*:</label>
              </b-col>
              <b-col sm="6">
                <!-- <b-form-input
                  v-model="form.comune"
                  type="text"
                  id="comune"
                  required
                  placeholder="Inserisci Comune*"
                  class="my-2"
                ></b-form-input>-->
                <b-form-select
                  id="comune"
                  class="my-2"
                  v-model="form.comune"
                  placeholder="Inserisci comune*"
                >
                  <b-form-select-option
                    v-for="(comune, ind) in comuni"
                    :key="ind"
                    :value="comune.comune"
                  >{{ comune.comune }}</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Indirizzo*:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  v-model="form.indirizzo"
                  type="text"
                  id="indirizzo"
                  required
                  placeholder="Inserisci Indirizzo*"
                  class="my-2"
                ></b-form-input>
              </b-col>
            </b-row>

            <div v-if="user.tipologia === 'professionista'">
              <b-row class="my-1 justify-content-around">
                <b-col sm="4" class="align-self-center text-left text-secondary">
                  <label for="nome" class="text-right">Specializzazione:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-select
                    id="specializzazione"
                    class="my-2"
                    v-model="form.categoria_id"
                    :options="categorie"
                    placeholder="Inserisci specializzazione"
                  ></b-form-select>
                </b-col>
              </b-row>

              <div v-if="isFarmacia">
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Partita Iva:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="form.partita_iva"
                      type="text"
                      id="partita_iva"
                      required
                      minlength="11"
                      maxlength="11"
                      placeholder="Inserisci partita iva*"
                      class="my-2"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1 justify-content-around">
                  <b-col sm="4" class="align-self-center text-left text-secondary">
                    <label for="nome" class="text-right">Denominazione:</label>
                  </b-col>
                  <b-col sm="6">
                    <b-form-input
                      v-model="form.denominazione"
                      type="text"
                      id="denominazione"
                      required
                      placeholder="Inserisci denominazione farmacia*"
                      class="my-2"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <b-row class="my-1 justify-content-around">
                <b-col sm="4" class="align-self-center text-left text-secondary">
                  <label for="nome" class="text-right">Cellulare:</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input
                    v-model="form.cellulare"
                    type="text"
                    id="cellulare"
                    placeholder="Inserisci numero di cellulare"
                    class="my-2"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Telefono*:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  v-model="form.telefono"
                  type="text"
                  id="telefono"
                  required
                  placeholder="Inserisci numero di telefono*"
                  class="my-2"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Codice Fiscale*:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  v-model="form.cf"
                  type="text"
                  id="cf"
                  required
                  minlength="16"
                  maxlength="16"
                  placeholder="Inserisci codice fiscale*"
                  class="my-2 text-uppercase"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-container>
        <div class="col-8 p-4 text-center mx-auto">
          <b-button
            block
            type="submit"
            variant="primary"
            class="rounded-pill py-2 font-weight-bold"
          >Salva dati anagrafici</b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner.vue";
export default {
  name: "RegisterAnagrafica",
  components: {
    Spinner
  },
  data() {
    return {
      form: {
        nome: "",
        cognome: "",
        categoria_id: null,
        regione: "",
        provincia: "",
        comune: "",
        indirizzo: "",
        telefono: "",
        cellulare: "",
        cf: "",
        partita_iva: "",
        denominazione: ""
      },
      user: this.$store.state.user,
      loading: true,
      categorie: [{ text: "Seleziona specializzazione", value: null }],
      regioni: null,
      province: null,
      comuni: null
    };
  },
  computed: {
    isFarmacia: function() {
      return this.user.role === "farmacista";
    }
  },
  methods: {
    getUser() {
      this.$axios
        .get("/v1/users/user")
        .then(res => {
          // console.log(res.data.data);
          this.user = res.data.data;
          this.loading = false;
          if (this.user.role != "paziente") {
            this.getCategorie();
          }
          if (this.user.anagrafica !== null) {
            this.$router.push({ name: "Profilo" });
          }
        })
        .catch(() => {
          this.$router.go();
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      // this.validate() && this.register();
      this.sendForm();
    },
    getCategorie() {
      var url =
        process.env.VUE_APP_VERSION + "categoria?ruolo=" + this.user.role;
      this.$axios
        .get(url)
        .then(res => {
          // console.log(res.data.data);
          // var categorie=res.data.data
          res.data.data.forEach(element => {
            this.categorie.push({ text: element.nome, value: element.id });
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getRegioni() {
      var url = process.env.VUE_APP_VERSION + "regioni";
      this.$axios
        .get(url)
        .then(res => {
          this.regioni = res.data.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getProvincie() {
      var url = process.env.VUE_APP_VERSION + "province";
      if (this.form.regione) {
        url = process.env.VUE_APP_VERSION + "province/" + this.form.regione;
      }

      this.$axios
        .get(url)
        .then(res => {
          this.province = res.data.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getComuni() {
      var url = process.env.VUE_APP_VERSION + "comuni";
      if (this.form.regione) {
        url =
          process.env.VUE_APP_VERSION + "comuni/regioni/" + this.form.regione;
        if (this.form.provincia) {
          url =
            process.env.VUE_APP_VERSION +
            "comuni/province/" +
            this.form.provincia;
        }
      }
      this.$axios
        .get(url)
        .then(res => {
          this.comuni = res.data.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    sendForm() {
      var url = process.env.VUE_APP_VERSION + this.user.role + "/register";
      this.$axios
        .post(url, this.form)
        .then(res => {
          // console.log(res.data.data);
          this.$emit("has-anagrafica");
          this.$router.push({ name: "Home" });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    !this.$store.state.user && this.getUser();
    this.getRegioni();
    this.getProvincie();
    this.getComuni();
  }
};
</script>
<style>
#cf::-webkit-input-placeholder {
  /* WebKit browsers */
  text-transform: none;
}
#cf:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
#cf::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  text-transform: none;
}
#cf:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  text-transform: none;
}
#cf::placeholder {
  /* Recent browsers */
  text-transform: none;
}
</style>
